import { registerPlugin } from '@capacitor/core';
import type { V2LauncherPlugin } from '@/native/plugins/V2Launcher/definitions';

const V2Launcher = registerPlugin<V2LauncherPlugin>('V2Launcher', {
  web: () => import('./web').then((m) => new m.V2LauncherWeb()),
});

export * from './definitions';
export * from './packageId';
export { V2Launcher };
